<template>
    <router-link
      v-if='name && itemId'
      tag='div'
      class='cur_p un_menuitem'
      activeClass='active'
      :to="'/category/' + category.id + '/item/' + itemId"
      exact>
      <p>{{ name }}</p>
    </router-link>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: 'Device or Product Model type'
    },
    itemId: {
      type: Number,
      required: true,
      default: 0
    },
    category: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.un_menuitem{
  position: relative;
  padding:0rem 2.5rem;
  border-radius:0.17rem;
  @include t_btn_hover;
  p{
    @include font-size(0.95);
    width:13rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #abaab8;
    padding: 0.85rem 0rem;
    &.active{
      background-color:rgba(255, 254, 242, 0.11);
      color: #ffffff;
    }
  }
  &:hover, &.active{
    p{
      color: rgb(0, 0, 255);
    }
  }
  &.active{
    background-color:rgba(255, 255, 255, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/Item.vue